/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { ListItem, ListItemProps, ListItemText, ListItemTextProps, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

export type EditableListItemProps = {
  ListItemTextProps?: ListItemTextProps;
  emptyPrimaryText?: ReactNode;
  primary?: ReactNode;
  secondary?: ReactNode;

  renderSecondary?: (props: ReactNode) => ReactNode;
  renderPrimary?: (props: ReactNode) => ReactNode;
} & ListItemProps;

export default function ListItemSkeleton({
  primary,
  secondary,
  renderSecondary = (secondary) => secondary,
  renderPrimary = (primary) => primary,
  emptyPrimaryText = 'Primary text label',
  ListItemTextProps,
  divider = true,
  ContainerComponent,
}: EditableListItemProps): JSX.Element {
  const primaryText = primary ? primary : emptyPrimaryText;
  const primaryValue = renderPrimary(primaryText);
  const secondaryValue = renderSecondary(secondary);

  return (
    <>
      <ListItem
        ContainerComponent={ContainerComponent}
        divider={divider}
        disableGutters={true}
        data-testid="list-item-skeleton"
      >
        <ListItemText
          primary={
            <Skeleton>
              <Typography variant="inherit" component="span">
                {primaryValue}
              </Typography>
            </Skeleton>
          }
          secondary={
            <Skeleton>
              <Typography variant="inherit" component="span">
                {secondaryValue}
              </Typography>
            </Skeleton>
          }
          primaryTypographyProps={{
            noWrap: true,
          }}
          secondaryTypographyProps={{
            noWrap: true,
          }}
          {...ListItemTextProps}
        />
      </ListItem>
    </>
  );
}
